import axios from 'axios';

import { PORTAL_V2_PUBLIC_API_BASE_URL } from '../constants';

export const getPrincipal = async () => {
  try {
    const principalResponse = await axios({
      method: 'GET',
      url: `${PORTAL_V2_PUBLIC_API_BASE_URL}/principal`,
      withCredentials: true,
    });

    return principalResponse?.data;
  } catch (error) {
    return null;
  }
};
